export default __webpack_public_path__ + "static/media/footer-faqs-icon.072b9a2d.svg";